if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        mobileUi: this.querySelector('[data-product-gallery-mobile-ui]'),
        mobileHitArea: this.querySelector('[data-product-gallery-mobile-hitarea]'),
        mobilePrev: this.querySelector('[data-product-gallery-mobile-ui] [data-gallery-nav="prev"]'),
        mobileNext: this.querySelector('[data-product-gallery-mobile-ui] [data-gallery-nav="next"]'),
        mobileCounterCurrent: this.querySelector('[data-product-gallery-mobile-ui] [data-gallery-current]'),
        mobileCounterTotal: this.querySelector('[data-product-gallery-mobile-ui] [data-gallery-total]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.viewer) return;

      this.elements.viewer.addEventListener('slideChanged', this.onViewerSlideChangedImmediate.bind(this));
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (!button) return;
          button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      }

      this.initMobileGestures();
      this.updateMobileCounter();
    }

    onSlideChanged(event) {
      if (!this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    onViewerSlideChangedImmediate(event) {
      this.updateMobileCounter(event?.detail?.currentPage);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      const isVertical = this.elements.thumbnails.classList.contains('slider-vertical');
      if (isVertical) {
        const list = this.elements.thumbnails.slider;
        const itemTop = thumbnail.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
        list.scrollTo({ top: itemTop, behavior: 'smooth' });
      } else {
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    updateMobileCounter(currentPageFromEvent) {
      if (!this.elements.mobileCounterCurrent || !this.elements.mobileCounterTotal) return;

      const current = currentPageFromEvent
        || this.elements.viewer?.currentPage
        || 1;
      // Total should match Liquid's computed media_count (source of truth),
      // since slider pagination math can differ from visible media count.
      const totalFromDom = parseInt(this.elements.mobileCounterTotal.textContent, 10);
      const total = Number.isFinite(totalFromDom) && totalFromDom > 0 ? totalFromDom : 1;

      if (this.elements.mobileUi) {
        this.elements.mobileUi.style.display = total > 1 ? '' : 'none';
      }

      this.elements.mobileCounterCurrent.textContent = String(current);
      this.elements.mobileCounterTotal.textContent = String(total);
    }

    getViewerSlider() {
      return this.elements.viewer?.slider || this.elements.viewer?.querySelector?.('[id^="Slider-"]');
    }

    getViewerSlides() {
      const upgradedSlides = this.elements.viewer?.sliderItemsToShow;
      if (Array.isArray(upgradedSlides) && upgradedSlides.length) return upgradedSlides;

      const nodes = Array.from(this.elements.viewer?.querySelectorAll?.('[id^="Slide-"]') || []);
      return nodes.filter((el) => el.clientWidth > 0);
    }

    getViewerCurrentIndex(slides, slider) {
      const currentPage = this.elements.viewer?.currentPage;
      if (typeof currentPage === 'number' && currentPage > 0) return currentPage - 1;

      const left = slider?.scrollLeft || 0;
      let bestIndex = 0;
      let bestDistance = Infinity;
      slides.forEach((el, idx) => {
        const d = Math.abs(el.offsetLeft - left);
        if (d < bestDistance) {
          bestDistance = d;
          bestIndex = idx;
        }
      });
      return bestIndex;
    }

    scrollViewerBy(delta) {
      const slider = this.getViewerSlider();
      const slides = this.getViewerSlides();
      if (!slider || slides.length < 2) return;

      const currentIndex = this.getViewerCurrentIndex(slides, slider);
      const nextIndex = (currentIndex + delta + slides.length) % slides.length;
      const target = slides[nextIndex];
      if (!target) return;

      slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      this.updateMobileCounter(nextIndex + 1);
    }

    initMobileGestures() {
      if (!this.elements.mobileHitArea) return;
      if (!this.elements.viewer) return;

      const hitArea = this.elements.mobileHitArea;
      const isMobileViewport = () => !this.mql.matches;
      const goPrev = () => this.scrollViewerBy(-1);
      const goNext = () => this.scrollViewerBy(1);

      // Let native horizontal swipe/scroll-snap work.
      // Only handle taps/clicks to jump prev/next.
      hitArea.addEventListener('click', (e) => {
        if (!isMobileViewport()) return;
        const rect = hitArea.getBoundingClientRect();
        const x = e.clientX - rect.left;
        if (x < rect.width / 2) goPrev();
        else goNext();
      });

      if (this.elements.mobilePrev) {
        this.elements.mobilePrev.addEventListener('click', (e) => {
          e.preventDefault();
          if (!isMobileViewport()) return;
          goPrev();
        });
      }
      if (this.elements.mobileNext) {
        this.elements.mobileNext.addEventListener('click', (e) => {
          e.preventDefault();
          if (!isMobileViewport()) return;
          goNext();
        });
      }
    }
  });
}
